import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Moment from 'react-moment'
import 'moment-timezone'

import { 
    useGetFormularioByIdQuery, 
    useDeleteFormularioSuscripcionMutation 
} from '../../../../store/api/endpoints/formularioSuscripcionApiSlice'

import { openFeedback } from '../../../../store/slices/feedback'

import HeaderVista from '../../../elementos/HeaderVista'
import Loading from '../../../elementos/Loading'

import Button from '@mui/material/Button'
import { Breadcrumbs, Divider, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'

import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined'
import DeleteIcon from '@mui/icons-material/Delete'

export default function FormularioSuscripcionEliminar() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams() // Capturamos el ID directamente de la ruta (ej: /formularios/eliminar/:id)

    // 1. Hook de Lectura (Query): Se ejecuta automáticamente al montar el componente con el 'id'
    const {
        data: responseGetRegistro,
        isLoading: isLoadingGetRegistro,
        isSuccess: isSuccessGetRegistro,
        isError: isErrorGetRegistro,
        error: errorDataGetRegistro,
    } = useGetFormularioByIdQuery(id)

    // 2. Hook de Mutación: Para ejecutar la acción de borrado
    const [
        removeRegistro,
        {
            isLoading: isLoadingRemoveRegistro,
            isSuccess: isSuccessRemoveRegistro,
            isError: isErrorRemoveRegistro,
            error: errorDataRemoveRegistro,
        }
    ] = useDeleteFormularioSuscripcionMutation()

    // Manejo de error al intentar leer el registro (ej: si el ID no existe)
    useEffect(() => {
        if (isErrorGetRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataGetRegistro?.data?.message || "Error al obtener el registro."
            }))
            navigate("/formularios/formulario-suscripcion")
        }
    }, [isErrorGetRegistro, errorDataGetRegistro, dispatch, navigate])

    // Manejo de error al intentar eliminar
    useEffect(() => {
        if (isErrorRemoveRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataRemoveRegistro?.data?.message || "No se pudo eliminar el registro."
            }))
        }
    }, [isErrorRemoveRegistro, errorDataRemoveRegistro, dispatch])

    // Éxito al eliminar
    useEffect(() => {
        if (isSuccessRemoveRegistro) {
            dispatch(openFeedback({
                severity: 'success',
                message: "¡Registro eliminado correctamente!"
            }))
            navigate("/formularios/formulario-suscripcion")
        }
    }, [isSuccessRemoveRegistro, navigate, dispatch])


    // Mientras carga la info o mientras se está borrando
    if (isLoadingGetRegistro || isLoadingRemoveRegistro) return (<Loading />)

    // Solo renderizamos si la data llegó con éxito
    if (isSuccessGetRegistro && responseGetRegistro) return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/formularios/formulario-suscripcion">
                            <Typography color="text.primary">Suscripciones</Typography>
                        </Link>
                        <Typography color="text.primary">{responseGetRegistro.titulo}</Typography>
                        <Typography color="text.primary">Eliminar</Typography>
                    </Breadcrumbs>
                }
                icon={<InventoryOutlinedIcon />}
            />
            
            <Grid container rowSpacing={2} columnSpacing={1} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 3 }}></Grid>
                
                <Grid size={{ xs: 12, md: 6 }}>
                    <h3>¿Eliminar Suscripción?</h3>
                    <p>
                        Se eliminará permanentemente la suscripción <b>{responseGetRegistro.titulo}</b> con 
                        un importe de <b>${responseGetRegistro.importe}</b>.
                    </p>
                    <p>
                        Vigencia: desde el <b><Moment date={responseGetRegistro.desde} format='DD-MM-YYYY HH:mm' tz="America/Argentina/Buenos_Aires" /></b>{' '}
                        hasta el <b><Moment date={responseGetRegistro.hasta} format='DD-MM-YYYY HH:mm' tz="America/Argentina/Buenos_Aires" /></b>.
                    </p>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Divider sx={{ my: 2 }} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Button 
                        onClick={() => removeRegistro(id)} 
                        type="button" 
                        variant="contained" 
                        color="error" 
                        startIcon={<DeleteIcon />} 
                    >
                        Eliminar
                    </Button>
                </Grid>
            </Grid>
        </>
    )

    return null
}